import React from 'react'
import account from '../assets/account.svg'
import printer from '../assets/printer.svg'
import SideBar from "./SideBar";

function NavBar() {
    return (
        <div className="topnav">
          <SideBar />
          <div className="nav-title">Rayy-Docs</div>
          <div className="profile" >
            <img src={printer} className="account-img" alt="printer" onClick={() => window.print()}/>
              <img src={account} className="account-img" alt="profile-pic" onClick={() => alert("This Feature is Coming soon . . .")}/>
          </div>
        </div>
    )
}

export default NavBar
